module.exports = __webpack_public_path__ + "static/wild-75d3d09f80d90603635098d097675eef.jpg";